import React from 'react';
import axios from 'axios';
import { Button, Form, Header, Segment } from 'semantic-ui-react';
import { ToastContainer } from 'react-toastify';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

class NewSP4 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            additionalInformationSource: this.props.additionalInformationSource,
            studyGoals: this.props.studyGoals,
            studyOutcomes: this.props.studyOutcomes,
            additionalInformationSourceEng: this.props.additionalInformationSourceEng,
            studyGoalsEng: this.props.studyGoalsEng,
            studyOutcomesEng: this.props.studyOutcomesEng
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.previousStep = this.previousStep.bind(this);
        this.step5 = this.step5.bind(this);
    }


    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }

    step5() {
        this.props.step5(
            this.state.additionalInformationSource,
            this.state.studyGoals,
            this.state.studyOutcomes,
            this.state.additionalInformationSourceEng,
            this.state.studyGoalsEng,
            this.state.studyOutcomesEng,
        );
    }

    previousStep() {
        const step = 3;
        this.props.previousStep(step);
    }


    render() {
        return (
            <div>
                <Header as="h1">Kreiranje implementacije smjera (studijskog programa)</Header>

                <Segment.Group raised>
                    <Segment raised>
                        <Header as="h3">
                            Ostali podaci o smjeru (studijskom programu)
                        </Header>
                    </Segment>
                    <Segment>
                        <Form>
                            <Form.Group widths="equal">
                                <Form.Field>
                                    <label>Izvor dodatnih informacija</label>
                                    <Form.TextArea
                                        placeholder="Bosanski / hrvatski / srpski"
                                        rows={5}
                                        value={this.state.additionalInformationSource}
                                        onChange={(e) => this.setState({ additionalInformationSource: e.target.value })}
                                    />
                                </Form.Field>
                                <Form.Field>
                                    <label>Izvor dodatnih informacija</label>
                                    <Form.TextArea
                                        placeholder="Engleski jezik"
                                        rows={5}
                                        value={this.state.additionalInformationSourceEng}
                                        onChange={(e) => this.setState({ additionalInformationSourceEng: e.target.value })}
                                    />
                                </Form.Field></Form.Group>
                            <Form.Group widths="equal">
                                <Form.Field>
                                    <label>Ciljevi učenja</label>
                                    <Form.TextArea
                                        placeholder="Bosanski / hrvatski / srpski"
                                        rows={5}
                                        value={this.state.studyGoals}
                                        onChange={(e) => this.setState({ studyGoals: e.target.value })}
                                    />
                                </Form.Field>
                                <Form.Field>
                                    <label>Ciljevi učenja</label>
                                    <Form.TextArea
                                        placeholder="Engleski jezik"
                                        rows={5}
                                        value={this.state.studyGoalsEng}
                                        onChange={(e) => this.setState({ studyGoalsEng: e.target.value })}
                                    />
                                </Form.Field>
                            </Form.Group>
                            <Form.Group widths="equal">
                                <Form.Field>
                                    <label>Ishodi učenja</label>
                                    <Form.TextArea
                                        placeholder="Bosanski / hrvatski / srpski"
                                        rows={5}
                                        value={this.state.studyOutcomes}
                                        onChange={(e) => this.setState({ studyOutcomes: e.target.value })}
                                    />
                                </Form.Field>
                                <Form.Field>
                                    <label>Ishodi učenja</label>
                                    <Form.TextArea
                                        placeholder="Engleski jezik"
                                        rows={5}
                                        value={this.state.studyOutcomesEng}
                                        onChange={(e) => this.setState({ studyOutcomesEng: e.target.value })}
                                    />
                                </Form.Field>
                            </Form.Group>
                        </Form>
                    </Segment>
                    <Segment clearing>
                        <Button
                            color="blue"
                            basic="true"
                            onClick={this.previousStep}
                        >Nazad</Button>
                        <Button
                            color="blue"
                            floated="right"
                            onClick={this.step5}
                        >Dalje</Button>

                    </Segment>
                    <ToastContainer hideProgressBar />
                </Segment.Group>
            </div>
        );
    }
}

export default NewSP4;



// WEBPACK FOOTER //
// ./src/views/Admin/CreateStudyProgramImplementation/NewSP4.js